import React from "react";
import MetricStatCard from "./MetricStatCard";
import { formatCurrencyUsd } from "../shared/utils/financeDisplay";

/**
 * Compact list summary for Insurance Management (filtered rows + expired KPI).
 * Uses platform `cards-wrapper--summary-compact`.
 */
export default function InsuranceSummaryStatCards({
  totalYearlyPremium,
  policyCount,
  expiredYearlyPremium,
  expiredPolicyCount,
  style,
  className,
}) {
  const yearly = Number(totalYearlyPremium) || 0;
  const count = Number(policyCount) || 0;
  const expiredYearly = Number(expiredYearlyPremium) || 0;
  const expiredCount = Number(expiredPolicyCount) || 0;
  const label =
    count > 0
      ? `Total Yearly Premium (${count.toLocaleString()})`
      : "Total Yearly Premium";
  const expiredLabel =
    expiredCount > 0
      ? `Expired Yearly Premium (${expiredCount.toLocaleString()})`
      : "Expired Yearly Premium";
  return (
    <div
      className={`cards-wrapper cards-wrapper--sm cards-wrapper--summary-compact${
        className ? ` ${className}` : ""
      }`}
      style={{ marginBottom: 8, ...style }}
      role="region"
      aria-label="Insurance summary"
    >
      <MetricStatCard
        label={label}
        value={formatCurrencyUsd(yearly)}
        valueStyle={{ color: "#2563eb" }}
      />
      <MetricStatCard
        label={expiredLabel}
        value={formatCurrencyUsd(expiredYearly)}
        valueStyle={{ color: "#dc2626" }}
      />
    </div>
  );
}
